<template>
  <div class="addFile">
    <div class="arrange">
      <div class="title">
        <strong>会诊记录</strong>
      </div>
      <div class="formContent">
        <mt-field :disabled="true" label="患者姓名" placeholder="请输入" v-model="ruleForm.name"></mt-field>
        <mt-field :disabled="true" label="年龄" placeholder="请输入" type="number" v-model="ruleForm.age"></mt-field>
        <!-- <mt-radio  title="性别" :options="options" v-model="ruleForm.sex"></mt-radio> -->
        <div class="radioGroup">
          <span>性别</span>
          <div class="radio-inline">
            <input disabled v-model="ruleForm.sex" id="man" type="radio" name="sex" value="男" checked/>
            <label for="man">男</label>
          </div>
          <div class="radio-inline">
            <input disabled v-model="ruleForm.sex" id="woman" type="radio" name="sex" value="女" />
            <label for="woman">女</label>
          </div>
        </div>
        <!-- <mt-field :disabled="true" label="病情简介/会诊原因" placeholder="请输入" type="textarea" rows="3" v-model="ruleForm.illnessRemark"></mt-field> -->
        <div class="text-area">
          <label for="bq">病情简介/会诊原因</label>
          <textarea disabled id="bq" cols="35" rows="5" placeholder="请输入" v-model="ruleForm.illnessRemark"></textarea>
        </div>

        <mt-field :disabled="isDisabled" style="ime-mode:disabled;" v-model="ruleForm.diagnosisDate" label="会诊时间" placeholder="请输入" type="datetime" @focus.native.capture="openData"></mt-field>
        <mt-datetime-picker
          ref="picker"
          type="datetime"
          v-model="pickerValue"
          @confirm="handleConfirm"
          :startDate="startDate">
        </mt-datetime-picker>
        <!-- <mt-field :disabled="isDisabled" label="会诊记录" placeholder="请输入" type="textarea" rows="3" v-model="ruleForm.records"></mt-field> -->
        <div class="text-area">
          <label for="record">会诊记录</label>
          <textarea :disabled="isDisabled" id="record" cols="35" rows="5" placeholder="请输入" v-model="ruleForm.records"></textarea>
        </div>
        <div class="btn-wrapper">
          <p class="btn" style="text-align:right;padding-right:2%;margin-bottom:15px">
            <mt-button type="default" size="small" @click="cancel">取消</mt-button>
            &emsp;
            <mt-button type="primary" size="small" @click="save" v-if="ruleForm.isCommit != true">保存</mt-button>
            &emsp;
            <mt-button type="primary" size="small" @click="submit" v-if="hasBoardroom&&ruleForm.isCommit!=true">提交</mt-button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { Indicator } from 'mint-ui'
import { MessageBox } from 'mint-ui'
import moment from 'moment'
export default {
  data() {
    return {
      hasBoardroom: true, // 是否有会议室
      pickerValue: '',
      startDate: '',
      isDisabled: false,
      submitIsShow: null,
      id: this.$route.query.rid,  //会诊申请id
      type: this.$route.query.type,
      topHospitalId: localStorage.getItem('HospitalID'),  //登录医院id
      // options: [{
      //   label: '男',
      //   value: '男',
      //   disabled: true
      // }, {
      //   label: '女',
      //   value: '女',
      //   disabled: true
      // }],
      ruleForm: {
        name: '',
        sex: '男',
        age: '',
        illnessRemark: '',  //会诊原因
        diagnosisDate: '',  //会诊时间
        records: '',  //会诊记录
      }
    }
  },
  created() {
    // let curDate = new Date()
    // this.startDate = new Date(curDate.getTime() - 60*60*1000); //前一天
    this.startDate = new Date()
    this.getBoardroom()
    this.record()
  },
  methods: {
    // 获取会议室
    getBoardroom() {
      this.Axios.get('/api/User/GetUserInfo')
        .then(res => {
          let data = res.data
          if (data.status === 100) {
            if (data.ret.boardroom) {
              if (data.ret.boardroom.value) {
                if (data.ret.boardroom.value.length <= 0) {
                  this.hasBoardroom = false
                }
              }
            }
            
          }
        })
        .catch(error => {
          Toast({
            message: '网络错误,请联系管理员!',
            position: 'top',
            duration: 1500
          });
        })
    },
    // 重置表单
    resetForm() {
      for (let item in this.ruleForm) {
        // console.log('formItem', this.ruleForm[item])
        if (item == 'diagnosisDate') {
          this.ruleForm[item] = null
        }
        this.ruleForm[item] = ''
        this.file = null
      }
      this.close()
    },
    // 点击取消按钮回到会诊页
    cancel() {
      this.$router.push({
        name: 'Consultation'
      })
    },
    openData() {
      this.$refs.picker.open()
      document.activeElement.blur()
    },
    // 选择时间
    handleConfirm() {
      this.ruleForm.diagnosisDate = this.pickerValue
      this.ruleForm.diagnosisDate = moment(new Date(this.ruleForm.diagnosisDate)).format('YYYY-MM-DD HH:mm')
    },
    // 进入会诊记录页面初始化数据
    record() {
      this.Axios.get('/api/Remote/GetRecordById?id=' + this.id).then(res => {
        let data = res.data
        data.data.diagnosisDate = moment(data.data.diagnosisDate).format('YYYY-MM-DD HH:mm')
        data.data.sex == 1 ? data.data.sex = '男' : data.data.sex = '女'
        this.ruleForm = data.data
        // console.log(data.data)
        data.data.isCommit == false ? this.isDisabled = false : this.isDisabled = true
        // if (data.data.isCommit) {
        //   for (let item of this.options) {
        //     this.$set(item, 'disabled', true)
        //   }
        // }
      })
      .catch(error => {
        console.log(error)
        Toast({
          message: '网络错误,请联系管理员!',
          position: 'top',
          duration: 1500
        });
      })
    },
    doRecord(isCommit) {
      let formdata = {
        isCommit: isCommit,
        name: this.ruleForm.name, //患者姓名
        age: this.ruleForm.age, //患者年龄
        sex: this.ruleForm.sex, //患者性别
        records: this.ruleForm.records, //记录
        illnessRemark: this.ruleForm.illnessRemark, //病情简介
        diagnosisDate: this.ruleForm.diagnosisDate //会诊日期
      }
      this.Axios.put('/api/Remote/UpdateRecordById?id=' + this.id, formdata).then(res => {
        // console.log(res.data)
        let data = res.data
        if (data.status == 100) {
          Toast({
            message: '记录成功!',
            position: 'top',
            duration: 1500
          });
          this.$router.push({
            name: 'Consultation'
          })
        } else {
          Toast({
            message: '修改失败!',
            position: 'top',
            duration: 1500
          });
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 提交记录 提交过后所有都不可改
    submit() {
      this.doRecord(true)
    },
    // 保存记录
    save() {
      this.doRecord(false)
    }
  }
}
</script>

<style lang="less">
.addFile {
  height: 99%;
  overflow: auto;
  // border: 1px solid rebeccapurple;
  .arrange {
    height: 100%;
    // border: 1px solid rebeccapurple;
    .title {
      font-size: 14px;
      height: 3%;
      padding: 2% 2%;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      background: #f5f5f9;
    }
    .formContent {
      .text-area {
        padding-left: 10px;
        padding-right: 5px;
        margin-top: 16px;
        &::after {
          content: "";
          display: block;
          width: 0;
          height: 0;
          clear: both;
        }
        textarea {
          outline: none;
          width: 63%;
          border: 1px solid #ccc;
          float: right;
        }
        label {
          display: block;
          width: 105px;
          float: left;
          top: 0;
        }
      }
      .radioGroup {
        height: 48px;
        line-height: 48px;
        padding: 0 10px;
        // border-top: 1px dotted #ccc;
        // border-bottom: 1px dotted #ccc;
        span {
          width: 105px;
          display: block;
          float: left;
        }
        .radio-inline {
          float: left;
          margin-right: 10px;
          input[type="radio"] + label::before {
            content: "\a0";
            display: inline-block;
            vertical-align: middle;
            width: 10px;
            height: 10px;
            margin-right: 5px;
            border-radius: 50%;
            text-indent: .15em;
            margin-bottom: 4px;
            border: 1px solid #CCCCCC;
            padding: 2px;
          }
          input[type="radio"] {
            position: absolute;
            clip: rect(0, 0, 0, 0);
          }
          input[type="radio"]:checked + label::before {
            background-color: #4A90E2;
            background-clip: content-box;
            padding: 2px;
          }
          input[type=radio][disabled]:checked + label::before{
            background-color:#CCCCCC;
            background-clip: content-box;
            padding: 2px;

          }
        }
      }
      .select-wrapper {
        padding-left: 2%;
        .hzHospital{
          background: rgba(0,0,0,0);
          width: 55%;
          height: 32px;
          font-family: "微软雅黑";
          font-size: 18px;
          color: #000;
          border: 1px #ccc solid;
          border-radius: 5px;
          // margin-left: 2%;
          outline: none;
          &:focus{
            border: 1px #ddd solid;
            box-shadow: 0 0 15px 1px #DDDDDD;
          }
          option{
            color: black;
            background: white;
            line-height: 20px;
            // &:hover{
            //   background: #EBCCD1;
            // }
          }
        }
      }
      .upload-wrapper {
        padding-left: 2%;
        font-size: 14px;
        .btn-wrapper {
          overflow: hidden;
          padding-right: 2%;
          .download {
            float: left;
            background: url('../../assets/u313.png') no-repeat;
            text-indent: 5%;
            margin-top: 6%;
          }
          .btn {
            float: right;
          }
        }
      }
      .boardroom {
        padding-left: 2%;
        .hzHospital{
          background: rgba(0,0,0,0);
          width: 55%;
          height: 32px;
          font-family: "微软雅黑";
          font-size: 18px;
          color: #000;
          border: 1px #ccc solid;
          border-radius: 5px;
          // margin-left: 2%;
          outline: none;
          &:focus{
            border: 1px #ddd solid;
            box-shadow: 0 0 15px 1px #DDD;
          }
          option {
            color: black;
            background: white;
            line-height: 20px;
            // &:hover{
            //   background: #EBCCD1;
            // }
          }
        }
      }
    }
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, select {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-ms-input-placeholder, textarea::-ms-input-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
}
</style>
